import DrawingToolOptions from './DrawingToolOptions';
import { withTranslation } from '../../withTranslation';

export default withTranslation()(DrawingToolOptions);
